"use strict";
/**
 * This code was AUTOGENERATED using the kinobi library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun kinobi to update it.
 *
 * @see https://github.com/metaplex-foundation/kinobi
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.transferAllSol = exports.getTransferAllSolInstructionDataSerializer = void 0;
const umi_1 = require("@metaplex-foundation/umi");
const serializers_1 = require("@metaplex-foundation/umi/serializers");
const shared_1 = require("../shared");
function getTransferAllSolInstructionDataSerializer() {
    return (0, serializers_1.mapSerializer)((0, serializers_1.struct)([['discriminator', (0, serializers_1.u8)()]], {
        description: 'TransferAllSolInstructionData',
    }), (value) => ({ ...value, discriminator: 1 }));
}
exports.getTransferAllSolInstructionDataSerializer = getTransferAllSolInstructionDataSerializer;
// Instruction.
function transferAllSol(context, input) {
    // Program ID.
    const programId = context.programs.getPublicKey('mplSystemExtras', 'SysExL2WDyJi9aRZrXorrjHJut3JwHQ7R9bTyctbNNG');
    // Accounts.
    const resolvedAccounts = {
        source: { index: 0, isWritable: true, value: input.source ?? null },
        destination: {
            index: 1,
            isWritable: true,
            value: input.destination ?? null,
        },
        systemProgram: {
            index: 2,
            isWritable: false,
            value: input.systemProgram ?? null,
        },
    };
    // Default values.
    if (!resolvedAccounts.source.value) {
        resolvedAccounts.source.value = context.identity;
    }
    if (!resolvedAccounts.systemProgram.value) {
        resolvedAccounts.systemProgram.value = context.programs.getPublicKey('splSystem', '11111111111111111111111111111111');
        resolvedAccounts.systemProgram.isWritable = false;
    }
    // Accounts in order.
    const orderedAccounts = Object.values(resolvedAccounts).sort((a, b) => a.index - b.index);
    // Keys and Signers.
    const [keys, signers] = (0, shared_1.getAccountMetasAndSigners)(orderedAccounts, 'programId', programId);
    // Data.
    const data = getTransferAllSolInstructionDataSerializer().serialize({});
    // Bytes Created On Chain.
    const bytesCreatedOnChain = 0;
    return (0, umi_1.transactionBuilder)([
        { instruction: { keys, programId, data }, signers, bytesCreatedOnChain },
    ]);
}
exports.transferAllSol = transferAllSol;
//# sourceMappingURL=transferAllSol.js.map